import React, { useState, useEffect } from 'react';
import news from '../../services/news.service';
import { useLocation, useNavigate } from 'react-router-dom';

const AnnouncementDetail = () => {
  const location = useLocation();
  const { title, content, image } = location.state; // Get the announcement's title, content, and image
  const [searchTerm, setSearchTerm] = useState('');
  const [announcements, setAnnouncements] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await news.getAllNews();
        setAnnouncements(response.data);
      } catch (err) {
        console.error('Error fetching announcements:', err);
      }
    };

    fetchAnnouncements();
  }, []);

  const filteredAnnouncements = announcements.filter(announcement =>
    announcement.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleAnnouncementClick = (announcement) => {
    navigate('/announcement', { state: { title: announcement.title, content: announcement.content, image: announcement.image } });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', marginTop: '100px',marginLeft:'30px' }}>
      <div style={{ flex: 3, padding: '20px' }}>
        <h3  style={{ marginTop: '50px' }}>{title}</h3>
        {image && (
          <img
            src={`${process.env.REACT_APP_API_URL}/${image}`}
            alt={title}
            style={{ width: '60%', height: '50vh', margin: '50px 20px 50px 20px' }}
          />
        )}
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      <div style={{ flex: 1, padding: '20px', borderTop: '1px solid #ccc' }}>
        <h3>Search News & Events</h3>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search..."
          style={{ width: '100%', padding: '8px', marginBottom: '10px' }}
        />
        <h4>Current Events and News</h4>
        <ul>
          {filteredAnnouncements.map((announcement, index) => (
            <li key={index} onClick={() => handleAnnouncementClick(announcement)} style={{ cursor: 'pointer', color: '#007bff' }}>
              <strong>{announcement.title}</strong> - {new Date(announcement.created_at).toLocaleDateString()}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AnnouncementDetail;